import { Component, OnInit, AfterContentChecked, ChangeDetectorRef, ElementRef, ViewChild, ViewChildren, QueryList, HostListener, AfterViewChecked, Renderer2, TemplateRef } from '@angular/core';
import { SearchContractPipe } from '../Models/search-contract.pipe';
import { ContractSearchService } from '../Services/contract-search.service';
import { ContractSections, ContractDetails } from '../Models/common.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-search-contract',
    templateUrl: './search-contract.component.html',
    providers: [SearchContractPipe]
})
export class SearchContractComponent implements OnInit, AfterContentChecked, AfterViewChecked {

    private _contractSections: ContractSections[];
    get contractSections(): ContractSections[] {
        return this._contractSections;
    }
    set contractSections(value: ContractSections[]) {
        this._contractSections = value;
    }
    contractDetails: ContractDetails;

    //activehighlightdeclaration
    filterMetadata = { count: 0 };
    index = { count: 0 };
    sectionCount = { count: 0 };
    initialLoad = true;
    expanded: boolean;
    sectionId: string;
    currentSectionId: string;
    isSectionExpanded: boolean;
    modalBody;
    popupName: string;
    toggleModalDisplay = "none";
    displayRomanListStyle: boolean;
    sectionIdStack: string[] = [];

    MatchDetails = [];

    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
        this.clearFilterCount();
    }

    @ViewChildren('section') sectionHtml: QueryList<ElementRef>;
    @ViewChildren('item') itemHtml: QueryList<ElementRef>;
    @ViewChildren('format') formatHtml: QueryList<ElementRef>;

    constructor(private cdRef: ChangeDetectorRef, private element: ElementRef, private highlightCount: SearchContractPipe, private dataService: ContractSearchService, private sanitizer: DomSanitizer, private renderer2: Renderer2) {
        let w = (window as any);
        w.openPopUp = this.myfunction.bind(this)
        w.scrollSection = this.sectionScroll.bind(this)
        this.dataService.getContractDetails().subscribe((data: ContractDetails) => {
            let year = data['PageName'].replace(/[^0-9]/g, '')
            this.contractDetails = data;
            this.contractSections = data['ContractSections'];            
            this.displayRomanListStyle = year == '' ? true : year < 2020;
            this.contractSections.forEach(sec => {
                sec.ContractItems.forEach(items => {
                    items.ContractItemBodyString = this.sanitizer.bypassSecurityTrustHtml(items.ContractItemBodyString) as string
                    items.ContractItemBody.Fragments.forEach(Fragment => { Fragment.InternalFormat = this.sanitizer.bypassSecurityTrustHtml(Fragment.InternalFormat) as string }
                    )
                })
            })
            this.dataService.setContractAdminLink(data['ContractAdminLink']);
            this.dataService.setContractAdminLinkText(data['ContractAdminLinkText']);
            this.dataService.setSearchTextPlaceholder(data['SearchTextPlaceholder']);
        });
    }   

    ngAfterViewChecked(): void {
        if (this.sectionId != undefined) {
            var targetSectionlink;
            var parentSectionlink;
            var parentSectionDivId;
            var subsectionDivId = this.element.nativeElement.querySelector(this.sectionId);
            if (subsectionDivId != undefined && this.isSectionExpanded != false) {
                this.element.nativeElement.querySelectorAll('[href="' + this.sectionId + '"]')
                    .forEach(elem => {
                        if (elem.hasAttribute('data-toggle')) { targetSectionlink = elem }
                    })
                if (targetSectionlink != undefined) {
                    if (targetSectionlink.parentElement.parentElement.getAttribute('class') != "swapa-contract p-0") {
                        parentSectionlink = targetSectionlink.parentElement.parentElement.previousElementSibling;
                        parentSectionDivId = targetSectionlink.parentElement.parentElement;
                        this.expandSectionLink(targetSectionlink, "h2");
                        //this.expandSectionLink(parentSectionlink, "h2");
                        this.expandSectionDiv(parentSectionDivId);
                        this.expandSectionDiv(subsectionDivId);
                        this.jumpTo(subsectionDivId);
                    }
                    else {
                        parentSectionlink = targetSectionlink;
                        parentSectionDivId = targetSectionlink.nextSibling;
                        this.expandParentSection(parentSectionlink, parentSectionDivId);
                    }
                }
                this.isSectionExpanded = false;     
            }
        }
    }


    onClick(event) {
        var targetSectionlink;
        var contentLink = event.target;
        if (contentLink != undefined) {
            var subsectionDivId = this.element.nativeElement.querySelector(contentLink.getAttribute('href'));
            this.element.nativeElement.querySelectorAll('[href="' + contentLink.getAttribute('href') + '"]')
                .forEach(elem => {
                    if (elem.hasAttribute('data-toggle')) { targetSectionlink = elem }
                })
            if (targetSectionlink.parentElement.parentElement.getAttribute('class') != "swapa-contract p-0") {
                var parentSectionlink = targetSectionlink.parentElement.parentElement.previousElementSibling;
                var parentSectionDivId = targetSectionlink.parentElement.parentElement;
                this.expandSectionLink(targetSectionlink, "h4");
                this.expandSectionLink(parentSectionlink, "h2");
                this.expandSectionDiv(parentSectionDivId);
                this.expandSectionDiv(subsectionDivId);

                this.jumpTo(subsectionDivId);
            }
            else {  
                parentSectionlink = targetSectionlink;
                parentSectionDivId = targetSectionlink.nextSibling;
                this.expandParentSection(parentSectionlink, parentSectionDivId);
            }

        }
    }

    expandParentSection(link, divId) {
        this.expandSectionLink(link, "h2");
        this.expandSectionDiv(divId);
        this.jumpTo(divId);
    }

    expandSectionLink(section, header) {
        if (section.getAttribute('class') != "swapa-contract-header swapa-accordion-prefix " + header + " collapsed") {
            section.setAttribute('class', "swapa-contract-header swapa-accordion-prefix " + header + " collapsed");
        }

        if (section.getAttribute('aria-expanded') != 'true') {
            section.setAttribute('aria-expanded', 'true');
        }
    }

    expandSectionDiv(sectionDivId) {
        if (sectionDivId.getAttribute('class') != "collapse show") {
            sectionDivId.setAttribute('class', 'collapse show');
        }
    }

    @HostListener('click') onClicks() { 
        
        var element = event.target as HTMLElement;
        if (element.getAttribute('class') == 'contentlink') {
            this.renderer2.listen(element, 'click', () => {
                this.onClick(events);   
            });
            let events: Event = new Event('click');
            element.dispatchEvent(events);
        }   
    }   

    clearFilterCount() {    
        this.index.count = 0;
        this.dataService.setCurrentPosition(this.index.count);
        this.filterMetadata.count = 0;
        this.dataService.setTotalSearchCount(this.filterMetadata.count);
        this.sectionCount.count = 0;
        this.MatchDetails = [];
        this.initialLoad = true;
    }

    ngOnInit(): void {
        this.dataService.getSearchstring$.subscribe((data) => {
            this.searchText = data;
        });

        this.dataService.getPosition$.subscribe((data) => {
            data > 0 ? this.findNext(data) : this.findPrev(data);
        });

        this.dataService.getExpandValue$.subscribe((data) => {
            if (data == true) {
                this.expandSections();
            }
        });

        this.dataService.getToggleEvent$.subscribe((data) => {
            this.toggleAllSections(data);
        });

        this.dataService.getQstringSectId$.subscribe((sectionId) => {
            if (sectionId != undefined) {
                this.sectionId = "#" + sectionId;
                this.isSectionExpanded = true;
            }
        });
    }

    ngAfterContentChecked(): void {
        this.cdRef.detectChanges();
    }

    public expandSections(): void {
        var sections = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > [aria-expanded=false]');
        if (sections.length > 0) {
            var header = this.element.nativeElement.querySelectorAll('.swapa-contract-header')
            this.setAttribute(header, "aria-expanded", true);
            var subSection = this.element.nativeElement.querySelectorAll('.swapa-contract .collapse');
            this.setAttribute(subSection, "class", "collapse show");
        }
    }

    toggleAllSections(event) {
        if (event != null) {
            var expanded = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > [aria-expanded=true]').length > 0;
            this.expanded = !this.expanded;
            if (expanded != undefined && expanded != null) {
                var subSection = this.element.nativeElement.querySelectorAll('.swapa-contract .collapse');
                var header2 = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > .swapa-contract-header')
                var header4 = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract >.swapa-contract > div >.swapa-contract > .swapa-contract-header')
                this.setAttribute(subSection, "class", expanded ? "collapse" : "collapse show");
                this.setAttribute(header2, "aria-expanded", expanded ? false : true);
                this.setAttribute(header2, "class", expanded ? "swapa-contract-header swapa-accordion-prefix h2" : "swapa-contract-header swapa-accordion-prefix h2 collapsed");
                this.setAttribute(header4, "aria-expanded", expanded ? false : true);
                this.setAttribute(header4, "class", expanded ? "swapa-contract-header swapa-accordion-prefix h4" : "swapa-contract-header swapa-accordion-prefix h4 collapsed");
            }
        }
    }

    public setAttribute(element, attr, val): void {
        if (element != null) {
            for (var item = 0; item < element.length; item++) {
                {
                    element[item].setAttribute(attr, val);
                }
            }
        }
    }

    public findNext(position: number) {
        var nextElem;
        this.sectionCount.count = 0;
        this.expand(position);
        this.find(position);

        var highlightedElem = this.element.nativeElement.querySelectorAll('mark');
        if (highlightedElem != null) {
            for (var elem = 0; elem < highlightedElem.length; elem++) {
                if (highlightedElem[elem].className == "swapa-contract-active") {
                    if (elem < (highlightedElem.length - 1)) {
                        nextElem = highlightedElem[elem + 1];
                    }
                    else {
                        (highlightedElem.length != 2) ? nextElem = highlightedElem[0] : nextElem = highlightedElem[elem - 1];
                    }
                }
            }
        }
        this.jumpTo(nextElem);
    }

    public findPrev(position: number) {
        var nextElem;
        this.sectionCount.count = this.MatchDetails.length;
        this.expand(position);
        this.find(position);

        var highlightedElem = this.element.nativeElement.querySelectorAll('mark');
        if (highlightedElem != null) {
            for (var elem = highlightedElem.length - 1; elem >= 0; elem--) {
                if (highlightedElem[elem].className == "swapa-contract-active") {
                    if (elem > 0) {
                        nextElem = highlightedElem[elem - 1];
                    }
                    else {
                        (highlightedElem.length != 2) ? nextElem = highlightedElem[highlightedElem.length - 1] : nextElem = highlightedElem[elem + 1];
                    }
                }
            }
        }
        this.jumpTo(nextElem);
    }

    public jumpTo(element): void {
        if (element != null) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    public expand(position): void {
        if (position != null || this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > [aria-expanded=false]').length > 0) {
            this.expanded = true;
        }
    }

    private find(increment: number) {
        if (this.searchText) {
            //this.matchCount = this.highlight.highlight(this.searchText, this.caseSensitive);
            this.index.count += increment;

            this.index.count = this.index.count <= 0 ? this.filterMetadata.count : this.index.count;
            this.index.count = this.index.count > this.filterMetadata.count ? 1 : this.index.count;
            this.dataService.setCurrentPosition(this.index.count);

            var that = this;

            if (this.filterMetadata.count > 0) {

                //that.sectionCount.count = 0
                var activePosition;
                this.dataService.getContractDetails().subscribe((data: ContractDetails) => {
                    this.contractSections = data['ContractSections'];
                    this.contractSections.forEach(sec => {
                        sec.ContractItems.forEach(items => {
                            items.ContractItemBodyString = this.sanitizer.bypassSecurityTrustHtml(items.ContractItemBodyString) as string
                            items.ContractItemBody.Fragments.forEach(Fragment => { Fragment.InternalFormat = this.sanitizer.bypassSecurityTrustHtml(Fragment.InternalFormat) as string }
                            )
                        })
                    })
                    for (var secItems = 0; secItems < this.contractSections.length; secItems++) {
                        for (var sec = 0; sec < that.MatchDetails.length; sec++) {
                            for (var item = 0; item < that.MatchDetails[sec].TotalHighlight.length; item++) {
                                if ((that.index.count - 1) == that.MatchDetails[sec].TotalHighlight[item]["highlight"]) {
                                    activePosition = that.MatchDetails[sec].TotalHighlight[item]["key"];
                                    that.sectionCount.count = sec;
                                }
                            }
                        }
                        if (activePosition != undefined) {
                            let finalvalue = that.formatHtml;
                            finalvalue.forEach((format: ElementRef) => {
                                var text = that.highlightCount.transform(format.nativeElement.innerHTML, that.searchText, that.sectionCount.count, that.MatchDetails, that.filterMetadata.count, that.index.count, that.initialLoad = false,format);
                                if (text.changingThisBreaksApplicationSecurity != undefined) {
                                    format.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                                }
                                else
                                    format.nativeElement.innerHTML = text;
                            });

                            let sectionValue = that.sectionHtml;
                            sectionValue.forEach((section: ElementRef) => {
                                var text = that.highlightCount.transform(section.nativeElement.innerHTML, that.searchText, that.sectionCount.count, that.MatchDetails, that.filterMetadata.count, that.index.count, that.initialLoad = false, section);
                                if (text.changingThisBreaksApplicationSecurity != undefined) {
                                    section.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                                }
                                else
                                    section.nativeElement.innerHTML = text;
                            });

                            let subsectionValue = that.itemHtml;
                            subsectionValue.forEach((subsect: ElementRef) => {
                                var text = that.highlightCount.transform(subsect.nativeElement.innerHTML, that.searchText, that.sectionCount.count, that.MatchDetails, that.filterMetadata.count, that.index.count, that.initialLoad = false, subsect);
                                if (text.changingThisBreaksApplicationSecurity != undefined) {
                                    subsect.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                                }
                                else
                                    subsect.nativeElement.innerHTML = text;
                            });
                            break;
                        }
                    }
                });
            }
        }
    }

    myfunction(id) {
        this.popupName = this.element.nativeElement.querySelector(`#name-${id}`).textContent;
        let eleRef = this.element.nativeElement.querySelector(`#${id}`);
        eleRef.querySelector('.swapa-top-shortcut').setAttribute('hidden','');
        this.modalBody = eleRef.innerHTML;
        this.toggleModalDisplay = "block";
        this.element.nativeElement.querySelector('#contractModal').setAttribute('class', 'modal fade show');
    }

    sectionScroll(id) {
            if (this.currentSectionId != "#" + id) {
                this.sectionIdStack.push(this.currentSectionId);
                this.element.nativeElement.querySelector('#back-' + id).removeAttribute('hidden', true);
            }
            this.sectionId = "#" + id;
            this.isSectionExpanded = true;
            this.currentSectionId = this.sectionId;
            if (this.sectionIdStack.length > 1) {
                for (var i = 0; i < this.sectionIdStack.length; i++) {
                    var sectionId = this.sectionIdStack[i].replace('#', '');
                    if (this.currentSectionId != this.sectionIdStack[i]) {
                        this.element.nativeElement.querySelector('#back-' + sectionId).setAttribute('hidden', true);
                    }
                }
            }
    }

    closePopup() {
        this.toggleModalDisplay = "none";
        this.element.nativeElement.querySelector('#contractModal').setAttribute('class', 'modal fade');
    }

    validatePageName(title) {
        let year = title.replace(/[^0-9]/g, '')
        return year == '' ? false : year < 2020 ;
    }

    navigateBack(): void {
        let divId;
        if (this.sectionIdStack.length > 0) {
            const lastSectionId = this.sectionIdStack[this.sectionIdStack.length - 1];
            this.sectionIdStack.pop();
            let section = this.element.nativeElement.querySelector(this.sectionId);
            let isExpanded = section.classList.contains('show');
            let toggleElement = this.element.nativeElement.querySelector(`a[href="${this.sectionId}"]`);
            if (toggleElement) {
                toggleElement.setAttribute('aria-expanded', !isExpanded.toString());
            }            
            section.setAttribute('aria-expanded', !isExpanded);
            section.classList.toggle('show', !isExpanded);
            divId = this.sectionId;
            this.sectionId = lastSectionId;
            this.currentSectionId = this.sectionId;
            this.isSectionExpanded = true;
        }
        this.element.nativeElement.querySelector('#back-' + divId.replace('#', '')).setAttribute('hidden', true);
        if (this.sectionIdStack.length > 0) {
            this.element.nativeElement.querySelector('#back-' + this.sectionId.replace('#', '')).removeAttribute('hidden', true);
        }
    }

    updateSectionId(id) {
        this.currentSectionId = "#" + id;
    }
}
